<template>
    <RadioGroupField
        v-model="form.smoke_regular"
        :error="translateMaybe(form.errors.smoke_regular)"
        :options="OPTIONS.SMOKER"
        name="smoke_regular"
        lg
        setup
        required
        :option-classes="grid.md ? 'text-h4' : ''"
    />
</template>

<script setup>
import RadioGroupField from "@/Components/FormFields/RadioGroupField.vue";
import { OPTIONS } from "@/Helpers/constants.js";
import { translateMaybe } from "@/Helpers/translateMaybe.js";
import { useForm } from "@inertiajs/vue3";
import { useGrid } from "vue-screen";

const props = defineProps({
    smokeRegular: {
        type: String,
        default: null,
    },
    form: {
        type: Object,
        default: null,
    },
});

const grid = useGrid("tailwind");

const form =
    props.form ??
    useForm({
        smoke_regular: props.smokeRegular,
    });
</script>
